import { render } from "./audit-trail.vue?vue&type=template&id=b2e725d6&scoped=true"
import script from "./audit-trail.vue?vue&type=script&lang=js"
export * from "./audit-trail.vue?vue&type=script&lang=js"

import "./audit-trail.vue?vue&type=style&index=0&id=b2e725d6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2e725d6"]])

export default __exports__